// extracted by mini-css-extract-plugin
module.exports = {"react-resizable":"style_react-resizable__3ppDO","react-resizable-handle":"style_react-resizable-handle__35ZCv"};